import { CheckIcon } from '@heroicons/react/20/solid';
import RenderAlignedHtml from '@bbkPricingPage/components/card/components/aligned-html-render';
import { getEffectiveAmount } from '@bbkPricingPage/helpers/amount-calculator';
import { PricingTableHelper } from '@bbkPricingPage/helpers/pricing-table-helper';
import { getFormattedAmount } from '@bbkPricingPage/lib/currencies';
import {
  PricingModel,
  type Frequency,
  type Price,
} from '@bbkPricingPage/types/pricing-table-types';

export const ChargeItem = ({
  name,
  description,
  quantity,
  chargePrice,
  frequency,
}: {
  name: string;
  description?: string;
  quantity?: number;
  chargePrice: Price;
  frequency: Frequency;
}) => {
  const priceSuffix = PricingTableHelper.generatePriceSuffix(frequency, true);
  const isQuantityBasedPrice =
    chargePrice.pricing_model !== PricingModel.flat_fee;

  // Set default quantity to 1 for non-flat fee pricing models
  const effectiveQuantity = isQuantityBasedPrice ? (quantity ?? 1) : 1;

  const chargeAmount = getEffectiveAmount(chargePrice, quantity, frequency);

  return (
    <div className="tw-pt-2">
      <div className="tw-flex tw-items-start tw-justify-between tw-gap-4">
        <div className="tw-max-w-[80%]">
          <h5 className="tw-flex tw-items-center tw-gap-2 tw-text-sm tw-font-semibold !tw-text-[var(--pricing-page-text-font-text-color)]">
            {name}
            <span className="tw-rounded-full tw-border tw-border-[color-mix(in_srgb,var(--pricingtable-style-accent-color)_40%,transparent)] tw-bg-[color-mix(in_srgb,var(--pricingtable-style-accent-color)_10%,transparent)] tw-px-2 tw-py-0.5 tw-text-xs tw-font-medium tw-text-[var(--pricingtable-style-accent-color)]">
              ONE-TIME
            </span>
          </h5>
          <span className="tw-text-sm tw-text-[color-mix(in_srgb,var(--pricing-page-text-font-text-color)_60%,transparent)]">
            <RenderAlignedHtml value={description ?? ''} />
          </span>
          {!!effectiveQuantity && isQuantityBasedPrice && (
            <span className="tw-mt-1 tw-block tw-font-medium !tw-text-[var(--pricing-page-text-font-text-color)]">
              {effectiveQuantity}
              <span className="tw-text-sm !tw-text-[var(--pricing-page-text-font-text-color)]">
                {effectiveQuantity === 1 ? ' Unit' : ' Units'}
              </span>
            </span>
          )}
        </div>
        <span className="tw-inline-flex tw-items-center tw-rounded-full tw-text-[color-mix(in_srgb,var(--pricing-page-text-font-text-color)_60%,transparent)]">
          <CheckIcon className="tw-mr-1 tw-h-5 tw-w-5 tw-text-[var(--pricingtable-style-accent-color)]" />
          Included
        </span>
      </div>
      <div className="tw-flex tw-items-center tw-justify-end">
        <div className="tw-text-right">
          <span className="tw-flex tw-flex-row tw-items-baseline tw-gap-1 tw-text-base tw-font-bold tw-text-[var(--pricing-page-text-font-text-color)]">
            {getFormattedAmount(chargeAmount, chargePrice.currency)}
            <span
              id={`frequency-priceSuffix-${frequency.period}-${frequency.period_unit}`}
              className="tw-text-sm tw-font-medium tw-text-[color-mix(in_srgb,var(--pricing-page-text-font-text-color)_60%,transparent)]"
            >
              {priceSuffix}
            </span>
          </span>
        </div>
      </div>
    </div>
  );
};
